import { useCallback, useEffect, useState } from 'react';
import { getAuditLogActions, getAuditLogs } from '../api/auditLogsApi';

const INITIAL_FILTERS = {
  action: '',
  entityType: '',
  userId: '',
  from: '',
  to: '',
};

export const useAuditLogsTable = () => {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [actionOptions, setActionOptions] = useState([]);

  const setFilter = useCallback((key, value) => {
    setPage(0);
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => {
    setPage(0);
    setFilters(INITIAL_FILTERS);
  }, []);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAuditLogs({
        page: page + 1,
        pageSize: rowsPerPage,
        ...filters,
      });
      setRows(data.data);
      setTotal(data.total);
    } catch (error) {
      console.error('Error al obtener el registro de auditoría:', error);
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, filters]);

  useEffect(() => {
    fetchLogs();
  }, [fetchLogs]);

  useEffect(() => {
    getAuditLogActions()
      .then(setActionOptions)
      .catch((error) => console.error('Error al obtener las acciones de auditoría:', error));
  }, []);

  return {
    rows,
    total,
    loading,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    filters,
    setFilter,
    resetFilters,
    actionOptions,
    fetchLogs,
  };
};
